"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.assign");
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const styled_components_1 = __importStar(require("styled-components"));
var LinkMask = function LinkMask(_ref) {
    var to = _ref.to, href = _ref.href, children = _ref.children, props = _objectWithoutPropertiesLoose(_ref, ["to", "href", "children"]);
    if (to)
        return /*#__PURE__*/ react_1.default.createElement(StyledLink, Object.assign({
            to: to
        }, props), children);
    return /*#__PURE__*/ react_1.default.createElement(AnchorMask, Object.assign({
        href: href
    }, props), children);
};
var maskStyle = styled_components_1.css(["position:absolute;display:block;z-index:10;top:0;left:0;width:100%;height:100%;padding:0;margin:0;border:0;pointer-events:", ";overflow:hidden;opacity:0;text-indent:-9999px;"], process.env.NODE_ENV === 'development' ? 'none' : 'all');
var AnchorMask = styled_components_1.default.a.withConfig({
    displayName: "LinkMask__AnchorMask",
    componentId: "sc-1595i21-0"
})(["", ""], maskStyle);
var StyledLink = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, props);
}).withConfig({
    displayName: "LinkMask__StyledLink",
    componentId: "sc-1595i21-1"
})(["", ""], maskStyle);
exports.default = LinkMask;
